import { request } from './utils'
import { captureSentryError } from '../services/sentry'

export const uploadPlaybook = async payload => {
    try {
        return request('/b/v1/playbookAction', 'POST', payload)
    } catch (e) {
        captureSentryError(e)
        return { error: e }
    }
}
